import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';

import { useSearchParams } from 'react-router-dom';
import { baseUrl, apiHelper } from 'helpers/util';

import SmallestHeading from 'components/SmallestHeading';
import SmallHeading from 'components/SmallHeading';

export default function Form() {
    const [ searchParams ] = useSearchParams();
    const [ topicInfo, setTopicInfo ] = useState({});
    const [ employees, setEmployees ] = useState([]);

    const loadTopicReport = function(topic) {
        const apiParams = { "topic": topic, "route": "folk_training.topic_report" }
        apiHelper.get({ "url": `${baseUrl}/.netlify/functions/erp_custom_api`,
            "params": apiParams })
        .then(response => {
            if (response.status) {
                setEmployees(response.json.message.employees);
                if (response.json.message.topic && response.json.message.topic.length > 0) {
                    setTopicInfo(response.json.message.topic[0]);
                }
            }
            else { console.log(response.json); }
        })
    }

    useEffect(function() {
        if (searchParams.get('topic')) {
            loadTopicReport(searchParams.get('topic'));
        }
    }, [])

    return (
        <Box sx={{ padding: '15px' }}>
            <SmallHeading>{topicInfo.name}</SmallHeading>
            <SmallestHeading>Instructor: {topicInfo.instructor}</SmallestHeading>
            <Box sx={{ whiteSpace: 'pre-wrap', marginTop: '5px' }}>Description: {topicInfo.description}</Box>
            <SmallHeading>Employees</SmallHeading>
            <Box sx={{ display: 'flex', maxWidth: '500px', width: '100%', flexWrap: 'wrap' }}>
                { employees.map(t => (
                    <FormControlLabel key={t.name} control={
                        <Checkbox disabled
                            name={t.name} checked={t.status == 'attended'} />
                    } label={t.full_name} />
                )) }
            </Box>
        </Box>
    );
}
